export default __webpack_public_path__ + "static/Real-Estate-idataworkers-2a61869db3e136bf1ba97f939b890bf3.svg";